<template>
    <EditDemandePrix/>
  </template>
  
  <script lang="ts">
    import EditDemandePrix from "@/components/GesCom/DemandePrix/EditDemandePrix.vue";
import { defineComponent } from "vue";
    export default defineComponent({
      name: "EditDemandePrixPage",
      components: {
        EditDemandePrix,
      },
    });
  </script>